import { CardBody } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { gameTeamShotMarkersAtom, unwrappedGameTeamShotMarkersAtom } from '@/atoms/queries/game/gameEventData';
import { CardHeightWrapper } from '@/components/card/CardHeightWrapper';
import { ErrorCard } from '@/components/contentState/ErrorCard';
import { ShotMap } from '@/components/visualisations/ShotMap/ShotMap';
import { useLoadableStatus } from '@/hooks/useLoadableStatus';
import { useStatus } from '@/hooks/useStatus';

const GameShotMapWithData = () => {
  const unwrappedTeamShotMarkers = useAtomValue(unwrappedGameTeamShotMarkersAtom);
  const status = useLoadableStatus(gameTeamShotMarkersAtom);
  const statusProps = useStatus('general', status);

  return (
    <CardHeightWrapper>
      <CardBody {...statusProps}>
        <ShotMap events={unwrappedTeamShotMarkers} />
      </CardBody>
    </CardHeightWrapper>
  );
};

export const GameShotMap = () => (
  <ErrorCard translationNameSpace="general" fallbackChildren={<ShotMap events={[]} />}>
    <GameShotMapWithData />
  </ErrorCard>
);
